module.exports = __webpack_public_path__ + "img/gb6562.prt.e5725a52.jpg";